
  <dx-drop-down-box *ngIf="data"
    [(value)]="code"
    [(opened)]="isGridBoxOpened"
    [valueExpr]="control?.kodField"
    [deferRendering]="false"
    [displayExpr]="displayText"
    placeholder="Seçiniz"
    [inputAttr]="{ 'aria-label': 'Owner' }"
    [showClearButton]="true"
    [dataSource]="data"
    [labelMode]="labelMode"
    [label]="labelText"
    [readOnly]="isReadOnly"
    (onValueChanged)="syncTreeViewSelection($event)"
    (onOptionChanged)="onGridBoxOptionChanged($event)"
  >
    <div *dxTemplate="let data1 of 'content'">
      <ng-container *ngIf="gridControlsList$ | async as gridControlsListItem">
        <dk-dx-data-table2
          class="px-7"
          [dataSource]="data"
          [columnList]="columns"
          [baseTable]="baseTable"
          [clearAllFilter]="isGridBoxOpened"
          height="100%"
          [columnTransactions]="false"
          [gridCtlList]="gridControlsListItem"
          (focusedRowChanged)="focusChanged($event)"
          (selectedRowData)="selectedRowData($event)"
          [isGroupingYn]="false"
        >
        </dk-dx-data-table2>
      </ng-container>
    </div>
  </dx-drop-down-box>